module.exports = __webpack_public_path__ + "static/media/how-to-cut-your-foods-carbon-footprint.da6425ba.jpg";